import { UNDEFINED_SPACE_KEY } from '../types/UNDEFINED_SPACE_KEY';
import { RepeatableSpace } from '../types/RepeatableSpace';
import { repeatableSpaceFactory } from './repeatableSpaceFactory';

export const getUndefinedRepeatableSpace = (_logError?: boolean): RepeatableSpace => {
  // TODO: log error here? should this ever be valid?
  return repeatableSpaceFactory(UNDEFINED_SPACE_KEY, [], false).get();
};
